import React from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import Categories from "../components/Categories";
import ProductSection from "../components/ProductSection";
import Testimonials from "../components/Testimonials";
import Newsletter from "../components/Newsletter";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div>
      {/* <Navbar /> */}
      <HeroSection />
      <Categories />
      <ProductSection
        title="Featured Products"
        subtitle="Discover our handpicked collection of trending items"
        apiEndpoint={`${process.env.REACT_APP_API_BASE_URL}/products/random?limit=4`}
      />
      <ProductSection
        title="New Products"
        subtitle="Fresh arrivals that define the latest fashion trends"
        apiEndpoint={`${process.env.REACT_APP_API_BASE_URL}/products/random?limit=4`}
        background="#f8f9fa"
      />
      <ProductSection
        title="Bestseller Products"
        subtitle="Customer favorites that never go out of style"
        apiEndpoint={`${process.env.REACT_APP_API_BASE_URL}/products/random?limit=4`}
      />
      <Testimonials />
      <Newsletter />
      <Footer />
    </div>
  );
};

export default Home;
